const override = false;
const config = {
    development: {
        APP_URL: 'https://staging.gohighlevel.com',
        STRIPE_JS_KEY: 'pk_test_WvH5LGch2F7bqyIJ6gVMu3iE',
        STRIPE_DASHBOARD_URL: 'https://dashboard.stripe.com/test',
        INTERNAL_TOOLS_SERVICE_URL: 'https://staging.services.leadconnectorhq.com/internal-tools',
        SAAS_SERVICE_URL: 'https://staging.services.leadconnectorhq.com/saas_service',
        BLADE_PLATFORM_URL: 'https://staging.services.leadconnectorhq.com/blade-platform',
        SAAS_BILLING_V2: 'https://staging.services.leadconnectorhq.com/saas-billing-v2',
        COMPANIES_SERVICE_URL: 'https://staging.services.leadconnectorhq.com/companies',
        USER_SERVICE_URL: 'https://staging.services.leadconnectorhq.com/users',
        LOCATION_SERVICE_URL: 'https://staging.services.leadconnectorhq.com/locations',
        APP_ENGINE_URL: 'https://highlevel-staging.appspot.com',
    },
    staging: {
        APP_URL: 'https://staging.gohighlevel.com',
        STRIPE_JS_KEY: 'pk_test_WvH5LGch2F7bqyIJ6gVMu3iE',
        STRIPE_DASHBOARD_URL: 'https://dashboard.stripe.com/test',
        INTERNAL_TOOLS_SERVICE_URL: 'https://staging.services.leadconnectorhq.com/internal-tools',
        SAAS_SERVICE_URL: 'https://staging.services.leadconnectorhq.com/saas_service',
        BLADE_PLATFORM_URL: 'https://staging.services.leadconnectorhq.com/blade-platform',
        SAAS_BILLING_V2: 'https://staging.services.leadconnectorhq.com/saas-billing-v2',
        COMPANIES_SERVICE_URL: 'https://staging.services.leadconnectorhq.com/companies',
        USER_SERVICE_URL: 'https://staging.services.leadconnectorhq.com/users',
        LOCATION_SERVICE_URL: 'https://staging.services.leadconnectorhq.com/locations',
        APP_ENGINE_URL: 'https://highlevel-staging.appspot.com',
    },
    production: {
        APP_URL: 'https://app.gohighlevel.com',
        STRIPE_JS_KEY: 'pk_live_MtxwO3obi7pfD7UZlGkfR2yj',
        STRIPE_DASHBOARD_URL: 'https://dashboard.stripe.com',
        GOOGLE_ANALYTICS_ID: 'UA-115177999-2',
        INTERNAL_TOOLS_SERVICE_URL: 'https://services.leadconnectorhq.com/internal-tools',
        SAAS_SERVICE_URL: 'https://services.leadconnectorhq.com/saas_service',
        BLADE_PLATFORM_URL: 'https://services.leadconnectorhq.com/blade-platform',
        SAAS_BILLING_V2: 'https://services.leadconnectorhq.com/saas-billing-v2',
        COMPANIES_SERVICE_URL: 'https://services.leadconnectorhq.com/companies',
        USER_SERVICE_URL: 'https://services.leadconnectorhq.com/users',
        LOCATION_SERVICE_URL: 'https://services.leadconnectorhq.com/locations',
        APP_ENGINE_URL: 'https://msgsndr.com',
    },
};
// local overrides
config.development = Object.assign({}, config.development);
if (override) {
    // do overrides here
}
export default config[process.env.mode];
